import { render, staticRenderFns } from "./home.vue?vue&type=template&id=21c88a7f&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=21c88a7f&prod&lang=less"
import style1 from "./home.vue?vue&type=style&index=1&id=21c88a7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c88a7f",
  null
  
)

export default component.exports